import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import { FormConsumer } from '../react-forms';
export default function withContext(WrappedComponent) {
  var displayName = WrappedComponent.name || WrappedComponent.displayName;

  function ContextWrapper(props) {
    return React.createElement(FormConsumer, null, function (reactForms) {
      return React.createElement(WrappedComponent, _extends({}, props, {
        reactForms: reactForms
      }));
    });
  }

  ContextWrapper.displayName = "withContext(".concat(displayName, ")");
  return ContextWrapper;
}